<template>
	<div class="row all-tickets">
        <!-- inicio modal -->
        <modal v-if="showModal" @close="voltar()">
            <div slot="header">
                <div class="tit">
                	<h2>Enviar documento</h2>
                </div>
            </div>
            <div slot="body">
            	<div class="row">
            		<div class="col-12">
            			<h3>Contrato Social</h3> <!-- muda de acordo com o tipo do arquivo-->

            			<!-- script do upload do arquivo  -->

            			<button>Enviar documento</button>
            		</div>
            	</div>
            </div>
        </modal>
        <!-- término modal -->
        <documentos-investidor v-if="type == 'INV'" :type="type" :id="id"></documentos-investidor>
        <documentos-emprestimo-pessoal v-if="type == 'EMPPES'" :type="type" :id="id"></documentos-emprestimo-pessoal>
        <documentos-emprestimo-coletivo v-if="type == 'EMPCOL'" :type="type" :id="id"></documentos-emprestimo-coletivo>
	</div>
</template>

<style lang="scss" scoped> 
  @import "../assets/styles/iouu/mixins";

  .box-td {
        &{
            border: none !important;
            padding: 0 !important;
        }
    }

  .table {

      th {

          &:nth-child(2) {
              // MEDIA max: 767px
              @include brkp-01(767px) {
                  width: 160px;
              }
          }

          &:nth-child(5) {
              // MEDIA max: 1230px
              @include brkp-01(1230px) {
                  width: 60px;
              }
          }

          &:nth-child(6) {
              // MEDIA max: 1300px
              @include brkp-01(1300px) {
                  display: none;
              }
          }

          &:nth-child(7),
          &:nth-child(8) {
              // MEDIA max: 1130px
              @include brkp-01(1130px) {
                  width: 40px;
              }
          }
      }

      td {

          &:nth-child(5) {
              // MEDIA max: 1300px
              @include brkp-01(1300px) {
                  text-align: center;
              }

              // MEDIA max: 1230px
              @include brkp-01(1230px) {
                  span {
                      &:last-child {
                          display: none;
                      }
                  }
              }
          }

          &:nth-child(6) {
              // MEDIA max: 1300px
              @include brkp-01(1300px) {
                  display: none;
              }
          }

          &:nth-child(7),
          &:nth-child(8) {
              // MEDIA max: 1130px
              @include brkp-01(1130px) {
                  a {
                      &{
                         font-size: 0;
                       }

                      i {
                          font-size: calcRem(25);
                      }
                  }
              }
          }

          i {
              font-size: calcRem(25);
          }

          .badge {
          	margin-left: 10px;
          }

          a {
              margin-left: 100px;
            
          }

      }
  }

  @include xs {
      .modal-body {
          width: 500px;
      }
  }

</style>

<script>
    //import Modal from "@/components/Modal";
    import DocumentosInvestidor from "@/components/Documentos/DocumentosInvestidor"
    import DocumentosEmprestimoColetivo from "@/components/Documentos/DocumentosEmprestimoColetivo"
    import DocumentosEmprestimoPessoal from "@/components/Documentos/DocumentosEmprestimoPessoal"

	export default {
		data() {
			return {
                showModal: false,
                type: this.$route.query.type,
                id: this.$route.query.id,
			};
        },
        
        components: {
            DocumentosInvestidor,
            DocumentosEmprestimoColetivo,
            DocumentosEmprestimoPessoal,
        },

		// methods: {
        //     components: { Modal }
        // }

        methods: {
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/perfil/documentos',
                    title: 'Documentos',
                })
            },
        },

        async created() {
            //tagueamento GA
            await this.taggingGA();
        }
	};
</script>


// WEBPACK FOOTER //
// src/views/Documentos.vue